// All categories
var allCategory = {
  followUp: "follow_up",
  firstFollowUp: "first_follow_up",
  lastFollowUp: "last_follow_up",
  tourFollowUp: "tour_follow_up", //Real-time and scheduler
  moveInCheckIn: "move-in_check-in",
  renewalCheckIn: "renewal_check-in",
  tourCheck: "tour_check",
  paidCheckIn: "paid_check-in",
  bookTour: "book_tour",
  leftOnRead: "left_on_read",
  unread: "unread",
  invoiceInfo: "invoice_info",
  renewalCheckInNoClient: "renewal_check-in_no_client",
  sharedUnitsNotes: "shared_units_notes"
};

// Categories allowed for AI to choose from
var aiCategory = {
  bookTour: allCategory.bookTour,
  invoiceInfo: allCategory.invoiceInfo
};

var subCategory = {
  [allCategory.followUp] : {
    firstFollowUp: "first_follow_up",
    secondFollowUp: "second_follow_up",
    thirdFollowUp: "third_follow_up",
    fourthFollowUp: "fourth_follow_up",
    fifthFollowUp: "fifth_follow_up",
    sixthFollowUp: "sixth_follow_up",
    ninetyDayFollowUp: "ninety_day_follow_up", //scheduled - 90 days since last text
    priorityFollowUp: "priority_follow_up"
  }
}

export const messageCategory = allCategory;
export const messageAiCategory = aiCategory;
export const messageSubCategory = subCategory;